export const AnchorDelayDirectionType = {
  AFTER: 'AFTER',
  BEFORE: 'BEFORE',
  ON: 'ON'
};